import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";
import React, { FunctionComponent } from "react";

export const CalendarIcon: FunctionComponent<SvgIconProps> = (props) => (
	<SvgIcon
		viewBox="0 0 24 24"
		{...props}
	>
		<path
			d="M5.7 2V3.8H4.8C3.801 3.8 3 4.601 3 5.6V18.2C3 19.19 3.801 20 4.8 20H10.29C11.424 21.116 12.981 21.8 14.7 21.8C18.183 21.8 21 18.983 21 15.5C21 13.781 20.316 12.224 19.2 11.09V5.6C19.2 4.61 18.399 3.8 17.4 3.8H16.5V2H14.7V3.8H7.5V2M4.8 5.6H17.4V7.4H4.8M4.8 9.2H17.4V9.803C16.581 9.416 15.663 9.2 14.7 9.2C11.217 9.2 8.4 12.017 8.4 15.5C8.4 16.463 8.616 17.381 9.003 18.2H4.8M14.7 11.135C17.112 11.135 19.065 13.088 19.065 15.5C19.065 17.912 17.112 19.865 14.7 19.865C12.288 19.865 10.335 17.912 10.335 15.5C10.335 13.088 12.288 11.135 14.7 11.135ZM13.8 12.8V16.121L16.671 17.777L17.346 16.607L15.15 15.338V12.8H13.8Z"
			fill="#79818F"
		/>
	</SvgIcon>
);

export default CalendarIcon;
